<div *ngIf="isProviderDisable" class="d-flex justify-content-center align-items-center text-white" style="height: 100vh !important">
    <div class="text-center">
        <div class="p-3" style="border: 1px solid #fff; border-radius: 10px;">
            <span class="i18n">{{ 'contents.provider.disable' | translate }}</span>
        </div>
    </div>
</div>
